// // import React from 'react';
// // import './footer.css'; // Import the CSS file for custom styles

// // const Footer = () => {
// //   return (
// //     <div className="footer-container">
// //       <div className="footer-content">
// //         {/* Left Section - Company Details */}
// //         <div className="footer-left">
// //           <h1>Sentinix</h1>
// //           <p>Conatct: +91 9385715037</p>
// //           <p>Email: Sentinix@company.com</p>
// //         </div>

// //         {/* Center Section - Content */}
// //         <div className="footer-center">
// //           <h5>Our Services</h5>
// //           <p>
// //             We provide innovative IT solutions to help businesses streamline their operations and improve efficiency.
// //             From software development to IT consulting, we cover a wide range of services that cater to your business needs.
// //           </p>
// //         </div>

// //         {/* Right Section - Social Media Icons */}
// //         <div className="footer-right">
// //           <h5>Follow Us</h5>
// //           <div className="social-icons">
// //             <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
// //               <i className="fab fa-facebook"></i>
// //             </a>
// //             <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
// //               <i className="fab fa-twitter"></i>
// //             </a>
// //             <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
// //               <i className="fab fa-linkedin"></i>
// //             </a>
// //             <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
// //               <i className="fab fa-instagram"></i>
// //             </a>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Footer Copyright */}
// //       <div className="footer-bottom">
// //         <p>&copy; {new Date().getFullYear()} Sentinix. All Rights Reserved.</p>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Footer;


// import React from 'react';
// import './footer.css';
// import logo from '../utils/Logo.jpeg'; // Adjust the path as needed
// import { Link } from 'react-router-dom';


// const Footer = () => {
//   return (
//     <div className="footer-container">
//       <div className="footer-content">

//         {/* Column 1 - Logo and Contact */}
//       <div className="footer-column">
//         <Link to="/">
//         <img src={logo} alt="Sentinix Logo" className="footer-logo" />
//         </Link>
//         <p>Contact: +91 6385478997</p>  
//         <p>Email: sentinixtechsolutions@gmail.com</p>
//       </div>


//         {/* Column 2 - Quick Access */}
//         <div className="footer-column">
//           <h5>Quick Links</h5>
//           <ul className="footer-links">
//             <li><a href="/">Home</a></li>
//             <li><a href="/about">About Us</a></li>
//             <li><a href="/service">Services</a></li>
//             <li><a href="/contact">Contact</a></li>
//             <li><a href="/terms">Terms & Conditions</a></li>
//             <li><a href="/shipping">Shipping & Delivery Policy</a></li>
//             <li><a href="/cancellation">Cancellation & Refund Policy</a></li>
//           </ul>
//         </div>

//         {/* Column 3 - Our Services */}
//         <div className="footer-column">
//           <h5>Our Services</h5>
//           <ul className="footer-links">
//             <li><a href="/service">Web Development</a></li>
//             <li><a href="/service">App Development</a></li>
//             <li><a href="/service">UI/UX Design</a></li>
//             <li><a href="/service">Cloud Solutions</a></li>
//           </ul>
//         </div>

//         {/* Column 4 - Social Media */}
//         <div className="footer-column">
//           <h5>Follow Us</h5>
//           <div className="social-icons">
//             <a href="https://www.facebook.com/share/16SSV4N2X6/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//               <i className="fab fa-facebook"></i>
//             </a>
//             {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//               <i className="fab fa-twitter"></i>
//             </a> */}
//             <a href="https://www.linkedin.com/company/105905591/admin/dashboard/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
//               <i className="fab fa-linkedin"></i>
//             </a>
//             <a href="https://www.instagram.com/sentinixtechsolutions?igsh=bDBxOTZ0NGN5cGZ5&utm_source=qr " target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//               <i className="fab fa-instagram"></i>
//             </a>
//           </div>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <p>&copy; {new Date().getFullYear()} Sentinix Tech Solutions Pvt Ltd. All Rights Reserved.</p>
//       </div>
//     </div>
//   );
// };

// export default Footer;

// import React, { useEffect, useState } from 'react';
// import './footer.css';
// import { Link } from 'react-router-dom';
// import api from '../../services/httpService';

// const Footer = () => {
//   const [contactInfo, setContactInfo]   = useState(null);
//   const [logoUrl, setLogoUrl]           = useState(null);
//   const [websiteName, setWebsiteName]   = useState("Sentinix Tech Solutions");

//   useEffect(() => {
//     fetchDashboard();
//     fetchContact();
//   }, []);

//   /* ── Logo + Website Name ── */
//   const fetchDashboard = async () => {
//     try {
//       const res = await api.get("/sentinix/dashboardsettings");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const latest  = allData.sort((a, b) => b.id - a.id)[0];
//         if (latest?.websiteLogo) setLogoUrl(latest.websiteLogo);
//         if (latest?.websiteName) setWebsiteName(latest.websiteName);
//       }
//     } catch (err) {
//       console.error("Footer: dashboard fetch error", err);
//     }
//   };

//   /* ── Phone, Email, Address, Socials ── */
//   const fetchContact = async () => {
//     try {
//       const res = await api.get("/sentinix/contactforms");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const info    = allData.find(item => item.title && item.title.trim() !== "");
//         setContactInfo(info || null);
//       }
//     } catch (err) {
//       console.error("Footer: contact fetch error", err);
//     }
//   };

//   return (
//     <div className="footer-container">
//       <div className="footer-content">

//         {/* ════════ Column 1 — Logo + Contact ════════ */}
//         <div className="footer-column">

//           {/* Logo — dynamic from dashboardsettings */}
//           <Link to="/">
//             {logoUrl ? (
//               <img src={logoUrl} alt={websiteName} className="footer-logo" />
//             ) : (
//               <div className="footer-logo-text">{websiteName}</div>
//             )}
//           </Link>

//           {/* Phone — dynamic from contactforms */}
//           <p className="footer-contact-item">
//             <span className="footer-contact-icon">📞</span>
//             {contactInfo?.Phone ? (
//               <a href={`tel:+91${contactInfo.Phone}`} className="footer-contact-link">
//                 +91 {contactInfo.Phone}
//               </a>
//             ) : (
//               <span>+91 6385478997</span>
//             )}
//           </p>

//           {/* Email — dynamic from contactforms */}
//           <p className="footer-contact-item">
//             <span className="footer-contact-icon">✉️</span>
//             {contactInfo?.Email ? (
//               <a href={`mailto:${contactInfo.Email}`} className="footer-contact-link">
//                 {contactInfo.Email}
//               </a>
//             ) : (
//               <span>sentinixtechsolutions@gmail.com</span>
//             )}
//           </p>

//           {/* Address — dynamic, show only if exists */}
//           {contactInfo?.Address && (
//             <p className="footer-contact-item">
//               <span className="footer-contact-icon">📍</span>
//               <span className="footer-address">{contactInfo.Address}</span>
//             </p>
//           )}
//         </div>

//         {/* ════════ Column 2 — Quick Links ════════ */}
//         <div className="footer-column">
//           <h5>Quick Links</h5>
//           <ul className="footer-links">
//             <li><a href="/">Home</a></li>
//             <li><a href="/about">About Us</a></li>
//             <li><a href="/service">Services</a></li>
//             <li><a href="/contact">Contact</a></li>
//             <li><a href="/terms">Terms &amp; Conditions</a></li>
//             <li><a href="/shipping">Shipping &amp; Delivery Policy</a></li>
//             <li><a href="/cancellation">Cancellation &amp; Refund Policy</a></li>
//           </ul>
//         </div>

//         {/* ════════ Column 3 — Our Services ════════ */}
//         <div className="footer-column">
//           <h5>Our Services</h5>
//           <ul className="footer-links">
//             <li><a href="/service">Web Development</a></li>
//             <li><a href="/service">App Development</a></li>
//             <li><a href="/service">UI/UX Design</a></li>
//             <li><a href="/service">Cloud Solutions</a></li>
//           </ul>
//         </div>

//         {/* ════════ Column 4 — Social Media (Dynamic) ════════ */}
//         <div className="footer-column">
//           <h5>Follow Us</h5>
//           <div className="social-icons">

//             {/* Facebook — dynamic URL, static fallback */}
//             <a
//               href={contactInfo?.Facebook || "https://www.facebook.com/share/16SSV4N2X6/?mibextid=wwXIfr"}
//               target="_blank" rel="noopener noreferrer" aria-label="Facebook"
//             >
//               <i className="fab fa-facebook"></i>
//             </a>

//             {/* LinkedIn — dynamic URL, static fallback */}
//             <a
//               href={contactInfo?.Linkedin || "https://www.linkedin.com/company/105905591/admin/dashboard/"}
//               target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
//             >
//               <i className="fab fa-linkedin"></i>
//             </a>

//             {/* Instagram — dynamic URL, static fallback */}
//             <a
//               href={contactInfo?.Instagram || "https://www.instagram.com/sentinixtechsolutions?igsh=bDBxOTZ0NGN5cGZ5&utm_source=qr"}
//               target="_blank" rel="noopener noreferrer" aria-label="Instagram"
//             >
//               <i className="fab fa-instagram"></i>
//             </a>

//             {/* WhatsApp — show only if admin entered number */}
//             {contactInfo?.WhatsappNumber && (
//               <a
//                 href={`https://wa.me/91${contactInfo.WhatsappNumber}`}
//                 target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
//               >
//                 <i className="fab fa-whatsapp"></i>
//               </a>
//             )}

//             {/* Twitter — show only if admin entered URL */}
//             {contactInfo?.Twitter && (
//               <a
//                 href={contactInfo.Twitter}
//                 target="_blank" rel="noopener noreferrer" aria-label="Twitter"
//               >
//                 <i className="fab fa-twitter"></i>
//               </a>
//             )}

//             {/* GitHub — show only if admin entered URL */}
//             {contactInfo?.GitHub && (
//               <a
//                 href={contactInfo.GitHub}
//                 target="_blank" rel="noopener noreferrer" aria-label="GitHub"
//               >
//                 <i className="fab fa-github"></i>
//               </a>
//             )}

//           </div>
//         </div>

//       </div>

//       {/* ════════ Footer Bottom ════════ */}
//       <div className="footer-bottom">
//         <p>
//           &copy; {new Date().getFullYear()}{" "}
//           {websiteName} Pvt Ltd. All Rights Reserved.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Footer;

import React, { useEffect, useState } from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import api from "../../services/httpService";

const Footer = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetchDashboard();
    fetchContact();
    fetchServices();
  }, []);

  /* ================= DASHBOARD SETTINGS ================= */
  const fetchDashboard = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const data = Array.isArray(res.data.data)
          ? res.data.data.sort((a, b) => b.id - a.id)[0]
          : res.data.data;

        setDashboardData(data);
      }
    } catch (err) {
      console.error("Footer dashboard error:", err);
    }
  };

  const fetchServices = async () => {
  try {
    const res = await api.get("/sentinix/services");
    if (res.data.success && res.data.data) {
      const serviceOnly = res.data.data.filter(
      (item) => item.type === "service" && !item.isDeleted
      );
     setServices(serviceOnly);
    }
  } catch (err) {
    console.error("Footer services error:", err);
  }
};

  /* ================= CONTACT SETTINGS ================= */
  const fetchContact = async () => {
    try {
      const res = await api.get("/sentinix/contactforms");
      if (res.data.success && res.data.data) {
        const data = Array.isArray(res.data.data)
          ? res.data.data.find((item) => item.title && item.title.trim() !== "")
          : res.data.data;

        setContactInfo(data);
      }
    } catch (err) {
      console.error("Footer contact error:", err);
    }
  };

  const websiteName =
    dashboardData?.websiteName || "Sentinix Tech Solutions";

  const logoUrl = dashboardData?.websiteLogo || null;

  return (
    <div className="footer-container">
      <div className="footer-content">

        {/* ================= Column 1 ================= */}
        <div className="footer-column">
          <Link to="/">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={websiteName}
                className="footer-logo"
              />
            ) : (
              <h4 className="footer-logo-text">{websiteName}</h4>
            )}
          </Link>

          {/* Phone */}
          <p className="footer-contact-item">
            📞{" "}
            {contactInfo?.Phone }
          </p>

          {/* Email */}
          <p className="footer-contact-item">
            ✉️{" "}
            {contactInfo?.Email}
          </p>

          {/* Address */}
          {contactInfo?.Address && (
            <p className="footer-contact-item">
              📍 {contactInfo.Address}
            </p>
          )}
        </div>

        {/* ================= Column 2 ================= */}
        <div className="footer-column">
          <h5>Quick Links</h5>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/service">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/shipping">Shipping & Delivery</Link></li>
            <li><Link to="/cancellation">Cancellation Policy</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

      {/* ================= Column 3 ================= */}
        <div className="footer-column">
          <h5>Our Services</h5>
          <ul className="footer-links">
            {services.length > 0 ? (
              services.map((service) => (
                <li key={service.id}>
                  <Link to="/service">
                    {service.name}
                  </Link>
                </li>
              ))
            ) : (
              <li>No Services Available</li>
            )}
          </ul>
        </div>

        {/* ================= Column 4 ================= */}
        <div className="footer-column">
          <h5>Follow Us</h5>
          <div className="social-icons">

            {contactInfo?.Facebook && (
              <a
                href={contactInfo.Facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook"></i>
              </a>
            )}

            {contactInfo?.Instagram && (
              <a
                href={contactInfo.Instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            )}

            {contactInfo?.Linkedin && (
              <a
                href={contactInfo.Linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            )}

            {contactInfo?.Twitter && (
              <a
                href={contactInfo.Twitter}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
            )}

            {contactInfo?.GitHub && (
              <a
                href={contactInfo.GitHub}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
            )}

            {contactInfo?.WhatsappNumber && (
              <a
                href={`https://wa.me/91${contactInfo.WhatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            )}

          </div>
        </div>
      </div>

      {/* ================= Footer Bottom ================= */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {websiteName}. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;